<template>
    <div>
        <Header title="Notification push" />
        <BackButton :baseUrl="urlIndex" />
        <div class="ppv2-min-h-screen">
            <div class="ppv2-rounded-lg ppv2-shadow-sm ppv2-p-8 ppv2-mb-7">
                <form
                    @submit.prevent="submitForm"
                    method="post"
                    enctype="multipart/form-data"
                    class="ppv2-shadow-md ppv2-rounded-2xl ppv2-p-6 ppv2-space-y-6"
                >
                    <!-- Title -->
                    <div class="text-center">
                        <h3 class="poppinsSemiBold ppv2-text-blue-600">Informations générales</h3>
                    </div>

                    <div class="ppv2-w-3/4 ppv2-mx-auto">
                        <!-- Objet / titre système -->
                        <div class="ppv2-mb-7">
                            <BaseInput
                                label="Objet/titre système"
                                type="text"
                                v-model="formData.system_title"
                                @input="clearError('system_title')"
                                required
                            />
                            <p v-if="formErrors.system_title" class="ppv2-text-[#ed4b9e] ppv2-text-sm">
                                {{ formErrors.system_title }}
                            </p>
                        </div>

                        <!-- Titre notification -->
                        <div class="ppv2-mb-7">
                            <BaseTextarea
                                id="title_notif"
                                v-model="formData.title_notif"
                                label="Titre de la notification"
                                placeholder="Titre de la notification"
                                :useEditor="true"
                                required
                                @input="clearError('title_notif')"
                            />
                            <p v-if="formErrors.title_notif" class="ppv2-text-[#ed4b9e] ppv2-text-sm">
                                {{ formErrors.title_notif }}
                            </p>
                        </div>

                        <!-- Description -->
                        <div class="ppv2-mb-7">
                            <BaseTextarea
                                id="desc_notif"
                                v-model="formData.desc_notif"
                                label="Description"
                                placeholder="Description"
                                :useEditor="true"
                                required
                                @input="clearError('desc_notif')"
                            />
                            <p v-if="formErrors.desc_notif" class="ppv2-text-[#ed4b9e] ppv2-text-sm">
                                {{ formErrors.desc_notif }}
                            </p>
                        </div>

                        <!-- Date & Time -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                            <div class="ppv2-mb-7">
                                <BaseTimeInput
                                    v-model="formData.send_time"
                                    label="Heure d'envoie"
                                    placeholder="09:00"
                                    required
                                    :step="15"
                                    @input="clearError('send_time')"
                                    input-class="rounded-md px-3 w-full"
                                    :customSizeLabel="12"
                                />
                                <p v-if="formErrors.send_time" class="ppv2-text-[#ed4b9e] ppv2-text-sm">
                                    {{ formErrors.send_time }}
                                </p>
                            </div>

                            <div class="ppv2-mb-7">
                                <DateInput
                                    required
                                    label="Date de fin"
                                    @input="clearError('end_date')"
                                    v-model="formData.end_date"
                                    :min-date="formData.id === 0 ? minDate : null"
                                />
                                <p v-if="formErrors.end_date" class="ppv2-text-[#ed4b9e] ppv2-text-sm">
                                    {{ formErrors.end_date }}
                                </p>
                            </div>
                        </div>

                        <!-- Buttons -->
                        <div class="ppv2-flex ppv2-justify-center ppv2-mt-8" :style="{ gap: normalizeSize(16, true) }">
                            <BaseButton id="reset" type="button" variant="outline" customClass="reset" @click="resetForm">
                                {{ $t('form_customer_v2.btn.reset') }}
                            </BaseButton>
                            <BaseButton type="submit" variant="primary">valider</BaseButton>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import Header from '../../Shared/Header.vue'
import BackButton from '../../Shared/BackButton.vue'
import BaseInput from '../../Shared/BaseInput.vue'
import BaseTextarea from '../../Shared/BaseTextarea.vue'
import BaseTimeInput from '../../Shared/BaseTimeInput.vue'
import DateInput from '../../Shared/DateInput.vue'
import BaseButton from '../../Shared/BaseButton.vue'
import ApiManager from './ApiManager.js'

export default {
    props: {
        urlIndex: String,
        id: {
            type: Number,
            required: true, // use Number instead of int
        },
        push_notif: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        Header,
        BackButton,
        BaseInput,
        BaseTextarea,
        BaseTimeInput,
        DateInput,
        BaseButton,
    },
    data() {
        return {
            minDate: this.toTomorrow(),
            formData: {
                system_title: '',
                title_notif: '',
                desc_notif: '',
                send_time: '',
                end_date: '',
                id: this.id,
            },
            fetchedNotif: {},
            formErrors: {},
        }
    },
    created() {
        this.loadPushNotif()
        this.initializeForm()
    },
    watch: {
        push_notif: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler(newVal) {
                this.$emit('update', newVal)
            },
            deep: true,
        },
    },
    methods: {
        normalizeSize,
        initializeForm(source = this.push_notif) {
            const fields = ['system_title', 'title_notif', 'desc_notif', 'send_time', 'end_date']
            fields.forEach((field) => {
                if (source && source.hasOwnProperty(field)) {
                    this.formData[field] = source[field]
                }
            })
        },
        async loadPushNotif() {
            if (this.id) {
                try {
                    this.fetchedNotif = await ApiManager.get(this.id)
                    console.log(this.fetchedNotif)
                    this.initializeForm(this.fetchedNotif)
                } catch (e) {
                    console.error('Failed to fetch notif:', e)
                }
            }
        },
        resetForm() {
            this.formData = {
                system_title: '',
                title_notif: '',
                desc_notif: '',
                send_time: '',
                end_date: '',
            }
        },
        async submitForm() {
            const isValid = this.validateForm()
            if (isValid) {
                try {
                    const _data = await ApiManager.update(JSON.stringify(this.formData))
                    this.$emit('submit', this.formData)
                    if (this.formData.id == 0) {
                        this.resetForm()
                    }
                    this.showMessageNotification(_data.message, 'success')
                } catch (e) {
                    this.showMessageNotification('Erreur lors de la soumission', 'error')
                }
            }
        },
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        validateForm() {
            this.formErrors = {}

            if (!this.formData.system_title) {
                this.formErrors.system_title = 'Le titre système est obligatoire.'
            }
            if (!this.formData.title_notif) {
                this.formErrors.title_notif = 'Le titre est obligatoire.'
            }
            if (!this.formData.desc_notif) {
                this.formErrors.desc_notif = 'La description est obligatoire.'
            }
            if (!this.formData.send_time) {
                this.formErrors.send_time = "L'heure est obligatoire."
            }
            if (!this.formData.end_date) {
                this.formErrors.end_date = 'La date de fin est obligatoire.'
            }

            return Object.keys(this.formErrors).length === 0
        },
        clearError(field) {
            if (this.formErrors[field]) {
                this.$delete(this.formErrors, field)
            }
        },
        toTomorrow() {
            const today = new Date()
            today.setDate(today.getDate() + 1) // add 1 day
            return today.toISOString().split('T')[0]
        },
    },
}
</script>
<style scoped>
.btn_submit_model {
    background: #021832;
    border: 1px solid #021832;
    width: 225px;
    height: 44px;
    angle: 0 deg;
    opacity: 1;
    gap: 8px;
    border-radius: 10px;
    border-width: 1px;
    padding: 10px;
}
.pos_btn_model {
    text-align: center;
}
.font_btn_model {
    font-family:
        Poppins Medium,
        sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
    line-height: 140%;
    color: #ffffff;
}
</style>
